import { render, staticRenderFns } from "./EtapasAtendimento.vue?vue&type=template&id=74696a5c&"
import script from "./EtapasAtendimento.vue?vue&type=script&lang=js&"
export * from "./EtapasAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports